import Footer from "../components/Footer/Footer";
import coachNandhaCutout from "../images/who-we-are/aboutImage.png";
import gymInterior1 from "../images/AboutPage/3.jpg";
import gymInterior2 from "../images/AboutPage/4.jpg";
import senthil from "../images/who-we-are/senthil.jpeg";
import {
  FaWhatsapp,
  FaPhone,
  FaTrophy,
  FaMedal,
  FaAward,
  FaCrown,
  FaBullseye,
  FaShieldHeart,
  FaDumbbell,
  FaCertificate,
  FaShieldHalved,
  FaAppleWhole,
  FaUserGroup,
  FaStar,
  FaEye,
} from "react-icons/fa6";

// Map icon name strings to React Icon components

function About() {
  const achievements = [
    {
      title: "MR. INDIA JUNIOR",
      category: "National Championship",
      desc: "Recognized at the highest national level for outstanding muscle density, aesthetic balance, and elite discipline.",
      Icon: FaTrophy,
      badge: "National Gold",
    },
    {
      title: "MR. SOUTH INDIA",
      category: "Regional Championship",
      desc: "Premier champion across the southern states, demonstrating conditioning and athletic stage presence.",
      Icon: FaMedal,
      badge: "South India #1",
    },
    {
      title: "MR. TAMIL NADU",
      category: "State Championship",
      desc: "State-level gold winner showcasing superior muscularity, work ethic, and periodized training execution.",
      Icon: FaAward,
      badge: "State Champion",
    },
    {
      title: "MR. COIMBATORE",
      category: "District Championship",
      desc: "District champion establishing authority, coaching credibility, and fitness leadership across Coimbatore.",
      Icon: FaCrown,
      badge: "District Gold",
    },
  ];

  // const founderHighlights = [
  //   { Icon: FaBullseye, text: "Founded in 2026 with a vision of accessible scientific fitness in Echanari, Coimbatore." },
  //   { Icon: FaShieldHeart, text: "Built a 100% inclusive unisex fitness environment welcoming men, women, and beginners." },
  //   { Icon: FaDumbbell, text: "Personally curated heavy-duty commercial equipment to ensure maximum safety and muscle gains." },
  // ];

  const pillars = [
    {
      title: "Commercial Heavy Gear",
      desc: "Biomechanically engineered pin-loaded and plate-loaded machines, Olympic squat racks, and heavy dumbbells for maximum muscle recruitment.",
      Icon: FaDumbbell,
      tag: "Top Grade Equipment",
    },
    {
      title: "Certified Coaching",
      desc: "Every workout is supervised by ICREPS internationally certified coaches ensuring safe joint mechanics, form checks, and spotted heavy lifts.",
      Icon: FaCertificate,
      tag: "Expert Guidance",
    },
    {
      title: "100% Unisex & Clean",
      desc: "A welcoming, inclusive, safe, and hygienic workout atmosphere engineered to empower men, women, and beginners alike.",
      Icon: FaShieldHalved,
      tag: "Safe & Supportive",
    },
    {
      title: "Tailored Nutrition Plans",
      desc: "Custom calorie-counted diet templates aligned with your body composition goals — fat loss, lean muscle gain, or strength prep.",
      Icon: FaAppleWhole,
      tag: "Scientific Diet",
    },
  ];

  const stats = [
    { number: "500+", label: "Transformations", Icon: FaUserGroup },
    { number: "4+", label: "Championship Titles", Icon: FaTrophy },
    { number: "100%", label: "Certified Guidance", Icon: FaCertificate },
    { number: "5.0 ★", label: "Google Member Rating", Icon: FaStar },
  ];

  return (
    <>
      <section className="bg-black text-white min-h-screen">
        {/* 1. Page Header Banner */}
        <div className="login-banner relative justify-center flex bg-brand-yellow">
          <h1 className="text-white absolute bottom-[20px] sm:bottom-[25px] text-[26px] sm:text-[34px] md:text-[40px] font-extrabold uppercase text-center px-4">
            About Us
          </h1>
        </div>

        {/* 2. Hero Story: Who We Are */}
        <div className="container page-padding py-12 sm:py-16 md:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
            {/* Left Content */}
            <div className="lg:col-span-7 text-center lg:text-left">
              <span className="inline-block text-[#ff0336] text-[11px] sm:text-[12px] font-bold uppercase tracking-[3px] mb-3">
                ★ Welcome to FAT2FIT Unisex Fitness Centre
              </span>
              <h2 className="text-[26px] sm:text-[34px] md:text-[42px] font-extrabold mb-5 sm:mb-6 leading-tight">
                Where Dedication Turns Into{" "}
                <span className="text-brand-yellow">Championship Results</span>
              </h2>
              <p className="text-neutral-300 text-[14px] sm:text-[16px] leading-relaxed mb-4">
                Located in <span className="text-white font-semibold">Echanari, Coimbatore</span>,{" "}
                <span className="text-brand-yellow font-semibold">FAT2FIT Unisex Fitness Centre</span> was built with a single mission: to provide high-end, science-backed fitness training accessible to everyone — from total beginners to competitive athletes.
              </p>
              <p className="text-neutral-400 text-[13.5px] sm:text-[15px] leading-relaxed mb-8">
                We combine commercial-grade biomechanical equipment, periodized workout programming, and personalized nutrition charts to deliver real, measurable transformations for our members.
              </p>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-3.5 sm:gap-4 justify-center lg:justify-start">
                <a
                  href="https://wa.me/918637488702?text=Hi%20Nandha%2C%20I%20visited%20your%20About%20page%20and%20want%20to%20know%20more%20about%20FAT2FIT%20gym!"
                  target="_blank"
                  rel="noreferrer"
                  className="bg-brand-yellow text-black font-bold uppercase text-[13px] sm:text-[14px] px-6 sm:px-8 py-3.5 sm:py-4 rounded-xl hover:bg-[#ff0336] hover:text-white transition duration-300 shadow-lg shadow-[#ffd60020] flex items-center justify-center gap-2"
                >
                  <FaWhatsapp className="text-lg" /> Inquire On WhatsApp
                </a>
                <a
                  href="tel:8637488702"
                  className="border-2 border-neutral-700 text-white hover:border-brand-yellow hover:text-brand-yellow font-bold uppercase text-[13px] sm:text-[14px] px-6 sm:px-8 py-3.5 sm:py-4 rounded-xl transition duration-300 flex items-center justify-center gap-2"
                >
                  <FaPhone className="text-sm" /> Call Coach Nandha
                </a>
              </div>
            </div>

            {/* Right Quick Overview Card */}
            <div className="lg:col-span-5 relative">
              <div className="relative rounded-3xl overflow-hidden border-2 border-neutral-800 hover:border-brand-yellow transition-all duration-500 bg-[#111] shadow-2xl group">
                <div className="h-[360px] sm:h-[420px] overflow-hidden relative">
                  <img
                    src={coachNandhaCutout}
                    alt="Coach G. Nandha Kumar"
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#111] via-transparent to-transparent opacity-90"></div>
                </div>

                <div className="p-6 pt-0 relative z-10 -mt-12 text-center">
                  <div className="inline-block bg-[#ff0336] text-white text-[10px] sm:text-[11px] font-extrabold uppercase px-3 py-1 rounded-full tracking-wider mb-2 shadow">
                    FAT2FIT Unisex Fitness Centre
                  </div>
                  <h3 className="text-[20px] sm:text-[24px] font-extrabold text-white mb-1">
                    G. Nandha Kumar
                  </h3>
                  <p className="text-brand-yellow text-[12px] sm:text-[13px] font-semibold">
                     Head Coach
                  </p>
                  <p className="text-neutral-400 text-[11.5px] sm:text-[12.5px] mt-2">
                    Mr. India Junior • Mr. South India • Mr. Tamil Nadu
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 3. Live Stats Bar */}
        <div className="bg-[#111] border-y border-neutral-800 py-10 sm:py-12">
          <div className="container page-padding">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
              {stats.map((stat, i) => (
                <div key={i} className="text-center group">
                  <div className="w-12 h-12 rounded-2xl bg-neutral-900 border border-neutral-800 flex items-center justify-center text-brand-yellow text-[18px] mx-auto mb-3 group-hover:bg-brand-yellow group-hover:text-black transition-colors duration-300">
                    <stat.Icon />
                  </div>
                  <div className="text-[28px] sm:text-[34px] md:text-[38px] font-black text-brand-yellow leading-none mb-1">
                    {stat.number}
                  </div>
                  <p className="text-neutral-400 text-[11px] sm:text-[12px] md:text-[13px] uppercase font-bold tracking-wider">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 6. Championship Achievements */}
        <div className="py-12 sm:py-16 md:py-20">
          <div className="container page-padding">
            <div className="text-center mb-12 sm:mb-16">
              <span className="text-[#ff0336] text-[11px] sm:text-[12px] font-bold uppercase tracking-[3px] block mb-2">
                Proven Track Record
              </span>
              <h2 className="text-[24px] sm:text-[30px] md:text-[36px] font-extrabold relative inline-block">
                Championship Accolades
                <span className="w-[80px] h-[4px] bg-brand-yellow absolute -bottom-3 left-1/2 -translate-x-1/2"></span>
              </h2>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {achievements.map((ach, i) => (
                <div
                  key={i}
                  className="bg-[#111] border border-neutral-800 p-6 sm:p-7 rounded-2xl text-center hover:border-brand-yellow transition-all duration-400 shadow-xl hover:-translate-y-1.5 flex flex-col justify-between group"
                >
                  <div>
                    <div className="w-14 h-14 bg-neutral-900 border border-neutral-800 rounded-2xl flex items-center justify-center mx-auto mb-4 text-brand-yellow text-[24px] group-hover:bg-brand-yellow group-hover:text-black transition-colors duration-300">
                      <ach.Icon />
                    </div>
                    <span className="inline-block bg-[#ff033618] text-[#ff0336] text-[10px] sm:text-[11px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-md mb-2">
                      {ach.badge}
                    </span>
                    <h3 className="text-[17px] sm:text-[19px] font-bold text-white mb-2 group-hover:text-brand-yellow transition-colors duration-300">
                      {ach.title}
                    </h3>
                    <p className="text-neutral-400 text-[12.5px] sm:text-[13px] leading-relaxed">
                      {ach.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 7. 4 Pillars of Excellence */}
        <div className="py-12 sm:py-16 md:py-20 bg-[#0a0a0c] border-t border-neutral-800">
          <div className="container page-padding">
            <div className="text-center mb-12 sm:mb-16">
              <span className="text-[#ff0336] text-[11px] sm:text-[12px] font-bold uppercase tracking-[3px] block mb-2">
                Why Train With Us
              </span>
              <h2 className="text-[24px] sm:text-[30px] md:text-[36px] font-extrabold relative inline-block">
                The FAT2FIT Difference
                <span className="w-[80px] h-[4px] bg-[#ff0336] absolute -bottom-3 left-1/2 -translate-x-1/2"></span>
              </h2>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {pillars.map((pil, i) => (
                <div
                  key={i}
                  className="bg-[#111] border border-neutral-800 rounded-2xl p-6 sm:p-7 hover:border-brand-yellow transition-all duration-400 shadow-lg hover:-translate-y-1.5 flex flex-col justify-between group"
                >
                  <div>
                    <div className="w-12 h-12 rounded-xl bg-neutral-900 border border-neutral-700 flex items-center justify-center text-[#ff0336] text-[20px] mb-5 group-hover:bg-[#ff0336] group-hover:text-white transition-colors duration-300">
                      <pil.Icon />
                    </div>
                    <span className="text-brand-yellow text-[10px] sm:text-[11px] font-bold uppercase tracking-wider block mb-1.5">
                      {pil.tag}
                    </span>
                    <h3 className="text-[17px] sm:text-[19px] font-bold text-white mb-2.5">
                      {pil.title}
                    </h3>
                    <p className="text-neutral-400 text-[12.5px] sm:text-[13.5px] leading-relaxed">
                      {pil.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 8. Mission & Vision Visual Grid */}
        <div className="bg-[#111] py-12 sm:py-16 md:py-20 border-t border-neutral-800">
          <div className="container page-padding">
            <div className="grid grid-cols-1 md:grid-cols-2 rounded-3xl overflow-hidden border border-neutral-800 shadow-2xl">
              {/* Mission Box */}
              <div className="bg-black p-8 sm:p-12 flex flex-col justify-center border-b md:border-b-0 md:border-r border-neutral-800 relative group">
                <div className="w-12 h-12 rounded-xl bg-neutral-900 border border-neutral-700 flex items-center justify-center text-[#ff0336] text-[22px] mb-4">
                  <FaBullseye />
                </div>
                <h3 className="text-[22px] sm:text-[26px] font-extrabold text-[#ff0336] mb-3">
                  Our Mission
                </h3>
                <p className="text-neutral-300 text-[13.5px] sm:text-[15px] leading-relaxed">
                  To empower every individual — regardless of their starting point — to achieve peak physical conditioning, strength, and confidence through world-class equipment, precise scientific programming, and relentless motivation.
                </p>
              </div>

              {/* Mission Image */}
              <div className="h-[260px] sm:h-[320px] md:h-auto overflow-hidden">
                <img
                  src={gymInterior1}
                  alt="FAT2FIT Training Center"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                />
              </div>

              {/* Vision Image */}
              <div className="h-[260px] sm:h-[320px] md:h-auto overflow-hidden order-last md:order-none">
                <img
                  src={gymInterior2}
                  alt="FAT2FIT Equipment Setup"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                />
              </div>

              {/* Vision Box */}
              <div className="bg-black p-8 sm:p-12 flex flex-col justify-center border-t md:border-t-0 border-neutral-800">
                <div className="w-12 h-12 rounded-xl bg-neutral-900 border border-neutral-700 flex items-center justify-center text-brand-yellow text-[22px] mb-4">
                  <FaEye />
                </div>
                <h3 className="text-[22px] sm:text-[26px] font-extrabold text-brand-yellow mb-3">
                  Our Vision
                </h3>
                <p className="text-neutral-300 text-[13.5px] sm:text-[15px] leading-relaxed">
                  To become the most respected and trusted fitness destination in Coimbatore — where health transformations are sustainable, injuries are prevented through proper biomechanics, and members build lasting healthy lifestyle habits.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* 9. Call To Action Banner */}
        <div className="py-16 sm:py-24">
          <div className="container page-padding">
            <div className="bg-[#111] border border-neutral-800 rounded-3xl p-8 sm:p-12 md:p-16 text-center max-w-4xl mx-auto relative overflow-hidden shadow-2xl">
              <div className="absolute top-0 left-0 w-full h-[6px] bg-brand-yellow"></div>
              
              <h3 className="text-[24px] sm:text-[30px] md:text-[36px] font-extrabold mb-3 sm:mb-4">
                Ready To Transform Your Life?
              </h3>
              <p className="text-neutral-300 text-[14px] sm:text-[16px] max-w-2xl mx-auto mb-8 leading-relaxed">
                Step into FAT2FIT Unisex Fitness Centre today. Book a free consultation and fitness assessment with Coach Nandha Kumar and get started on your customized program.
              </p>

              <div className="flex flex-col sm:flex-row gap-3.5 sm:gap-4 justify-center">
                <a
                  href="https://wa.me/918637488702?text=Hi%20Coach%20Nandha%2C%20I%20want%20to%20book%20a%20free%20trial%20session%20at%20FAT2FIT!"
                  target="_blank"
                  rel="noreferrer"
                  className="bg-brand-yellow text-black font-bold uppercase text-[13px] sm:text-[14px] px-8 py-4 rounded-xl hover:bg-[#ff0336] hover:text-white transition duration-300 shadow-lg shadow-[#ffd60020] flex items-center justify-center gap-2"
                >
                  <FaWhatsapp className="text-lg" /> Book Free Trial
                </a>
                <a
                  href="tel:8637488702"
                  className="border-2 border-neutral-700 text-white hover:border-brand-yellow hover:text-brand-yellow font-bold uppercase text-[13px] sm:text-[14px] px-8 py-4 rounded-xl transition duration-300 flex items-center justify-center gap-2"
                >
                  <FaPhone className="text-sm" /> Call 8637488702
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <Footer />
      </section>
    </>
  );
}

export default About;
